import { Routes } from '@angular/router'
import { ProductConfigurationIdResolver } from './resolvers/productConfigurationId.resolver'

export const configurationDealIdResolverRoutes: Routes = [
    {
        path: '',
        loadChildren: () =>
            import('modules/deals/configurator/factory/configurator-factory.module').then(
                m => m.ConfiguratorFactoryModule
            ),
        resolve: {
            productConfigurationId: ProductConfigurationIdResolver,
        },
    },
]
